import type { PropsWithChildren } from 'react'

import TableRow from '@mui/material/TableRow'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'

import type { Campaign } from '../../types'

import { Actions } from './Actions'
import { CommonCells } from './CommonCells'
import { LastCells } from './LastCells'
import { NameCell } from './NameCell'
import { StatusCell } from './Status'
import css from './style.module.css'

Row.NameCell = NameCell
Row.CommonCells = CommonCells
Row.LastCells = LastCells
Row.Actions = Actions
Row.StatusCell = StatusCell

export function Row({ children, id }: PropsWithChildren<Pick<Campaign, 'id'>>) {
	const navigate = useNavigate()

	return (
		<TableRow
			className={clsx('table-row', css.row)}
			onClick={() => navigate(`./${id}`)}
		>
			{children}
		</TableRow>
	)
}
